import * as customersApi from '@/network/api/customers/customers.api.js'
import * as invoicingApi from '@/network/api/invoicing.api.js'

/** requests to List of Associated Customers
@return { promise }
*/
export const requestAssociatedCustomers = async (context, payload) => {
    const res = await customersApi.requestAssociatedCustomers(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ASSOCIATED_CUSTOMERS', data)
    }
    return res
}

/** requests to List of Associated Customers
@return { promise }
*/
export const requestInvoicingDownload = async (context, payload) => {
    const res = await invoicingApi.requestInvoicingDownload(payload)
    return res
}
